/**
 * Environment-aware logging utility
 * 
 * This logger only outputs to console in development mode.
 * In production builds, all logging is suppressed to prevent
 * information leakage through browser developer tools.
 * 
 * SECURITY: Never log sensitive data (emails, tokens, passwords)
 * even in development mode. Use generic identifiers instead.
 */

const isDevelopment = import.meta.env.DEV;

interface Logger {
  log: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
}

export const logger: Logger = {
  log: (...args: unknown[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  error: (...args: unknown[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  info: (...args: unknown[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  debug: (...args: unknown[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
};

export default logger;
